// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

/**
 * ValidationError
 */
export type ValidationError = {
    /**
     * Location
     */
    loc: Array<string | number>;
    /**
     * Message
     */
    msg: string;
    /**
     * Error Type
     */
    type: string;
};

/**
 * SummarySchool
 */
export type SummarySchool = {
    /**
     * Name
     */
    name: string;
    /**
     * Nces Id
     */
    nces_id: string;
    physical_address: SummaryAddress;
};

/**
 * SummaryAddress
 */
export type SummaryAddress = {
    /**
     * Line 1
     */
    line_1: string;
    /**
     * City
     */
    city: string;
    /**
     * State
     */
    state: string;
    /**
     * Zipcode
     */
    zipcode: string;
};

/**
 * SummaryDistrict
 */
export type SummaryDistrict = {
    /**
     * Name
     */
    name: string;
    /**
     * Nces Id
     */
    nces_id: string;
    physical_address: SummaryAddress;
    /**
     * Schools
     */
    schools: Array<SummarySchool>;
};

/**
 * StateWithScrapersItem
 */
export type StateWithScrapersItem = {
    /**
     * Uuid
     */
    uuid: string;
    abbreviation: StateAbbreviation;
};

/**
 * StateAbbreviation
 */
export const StateAbbreviation = {
    AK: 'AK',
    AL: 'AL',
    AR: 'AR',
    AZ: 'AZ',
    CA: 'CA',
    CO: 'CO',
    CT: 'CT',
    DC: 'DC',
    DE: 'DE',
    FL: 'FL',
    GA: 'GA',
    HI: 'HI',
    IA: 'IA',
    ID: 'ID',
    IL: 'IL',
    IN: 'IN',
    KS: 'KS',
    KY: 'KY',
    LA: 'LA',
    MA: 'MA',
    MD: 'MD',
    ME: 'ME',
    MI: 'MI',
    MN: 'MN',
    MO: 'MO',
    MS: 'MS',
    MT: 'MT',
    NC: 'NC',
    ND: 'ND',
    NE: 'NE',
    NH: 'NH',
    NJ: 'NJ',
    NM: 'NM',
    NV: 'NV',
    NY: 'NY',
    OH: 'OH',
    OK: 'OK',
    OR: 'OR',
    PA: 'PA',
    RI: 'RI',
    SC: 'SC',
    SD: 'SD',
    TN: 'TN',
    TX: 'TX',
    UT: 'UT',
    VA: 'VA',
    VT: 'VT',
    WA: 'WA',
    WI: 'WI',
    WV: 'WV',
    WY: 'WY'
} as const;

/**
 * StateAbbreviation
 */
export type StateAbbreviation = typeof StateAbbreviation[keyof typeof StateAbbreviation];

/**
 * StateWithProductsItem
 */
export type StateWithProductsItem = {
    /**
     * Uuid
     */
    uuid: string;
    abbreviation: StateAbbreviation;
    /**
     * Active Products
     */
    active_products: Array<NimbleProduct>;
};

/**
 * NimbleProduct
 */
export const NimbleProduct = {
    SCRAPERS: 'scrapers',
    DISCOVER: 'discover',
    INSIGHT: 'insight',
    NAVIGATE: 'navigate'
} as const;

/**
 * NimbleProduct
 */
export type NimbleProduct = typeof NimbleProduct[keyof typeof NimbleProduct];

/**
 * StateProductsResponse
 */
export type StateProductsResponse = {
    /**
     * Products
     */
    products: Array<NimbleProduct>;
};

/**
 * StaleJobPostingsPage
 */
export type StaleJobPostingsPage = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number;
    /**
     * Size
     */
    size: number;
    /**
     * Pages
     */
    pages: number;
    /**
     * Items
     */
    items: Array<StaleJobPostingSummary>;
};

/**
 * JobPostingSource
 */
export const JobPostingSource = {
    INDEED: 'indeed',
    ZIPRECRUITER: 'ziprecruiter',
    TALEO: 'taleo',
    APPLITRACK: 'applitrack',
    APPLITRACK_ZIPRECRUITER: 'applitrack_ziprecruiter',
    TALENTED: 'talented',
    SCHOOLSPRING: 'schoolspring',
    NIMBLE_HIRE: 'nimble_hire',
    NIMBLE_COHIRE: 'nimble_cohire',
    POWERSCHOOL: 'powerschool',
    SKYWARD: 'skyward',
    RDSAPPTRACKING: 'rdsapptracking',
    MYSMARTHIRE: 'mysmarthire',
    TYLERTECHNOLOGIES: 'tylertechnologies',
    ICIMS: 'icims',
    LGC: 'lgc',
    ACTIVEAPPLICANT: 'activeapplicant',
    JOBADDER: 'jobadder',
    SWEEPBOT: 'sweepbot',
    REDROVER: 'redrover',
    ORACLECLOUD: 'oraclecloud',
    WORKDAY: 'workday',
    PAYLOCITY: 'paylocity',
    SMARTRECRUITERS: 'smartrecruiters',
    BAMBOOHR: 'bamboohr',
    LEVER: 'lever',
    JAZZHR: 'jazzhr',
    MOCAREERS: 'mocareers'
} as const;

/**
 * JobPostingSource
 */
export type JobPostingSource = typeof JobPostingSource[keyof typeof JobPostingSource];

/**
 * StaleJobPostingSummary
 */
export type StaleJobPostingSummary = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Job Id
     */
    job_id: string | null;
    /**
     * Job Url
     */
    job_url: string;
    /**
     * Title
     */
    title: string;
    /**
     * Job Description
     */
    job_description: string;
    /**
     * Location
     */
    location: string;
    source: JobPostingSource;
    /**
     * Nces District Id
     */
    nces_district_id: string;
    district: SummaryDistrict;
};

/**
 * SearchSchoolsPage
 */
export type SearchSchoolsPage = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number;
    /**
     * Size
     */
    size: number;
    /**
     * Pages
     */
    pages: number;
    /**
     * Items
     */
    items: Array<SearchSchoolSummary>;
    /**
     * Total Jobs
     */
    total_jobs?: number;
};

/**
 * PooledPostingType
 */
export const PooledPostingType = {
    POOLED_POSTING: 'pooled_posting',
    SINGLE_POSTING: 'single_posting'
} as const;

/**
 * PooledPostingType
 */
export type PooledPostingType = typeof PooledPostingType[keyof typeof PooledPostingType];

/**
 * SearchSchoolJobPostingSummary
 */
export type SearchSchoolJobPostingSummary = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Title
     */
    title: string;
    /**
     * Subcategories
     */
    subcategories: Array<string>;
    pooled_posting_type: PooledPostingType | null;
};

/**
 * PrincipalSubscriptionStatus
 */
export const PrincipalSubscriptionStatus = {
    ON_PLATFORM: 'on_platform',
    OFF_PLATFORM: 'off_platform',
    UNSUBSCRIBED: 'unsubscribed'
} as const;

/**
 * PrincipalSubscriptionStatus
 */
export type PrincipalSubscriptionStatus = typeof PrincipalSubscriptionStatus[keyof typeof PrincipalSubscriptionStatus];

/**
 * NCESSnapshotSchoolSummary
 */
export type NcesSnapshotSchoolSummary = {
    /**
     * School Type
     */
    school_type?: string;
    /**
     * Student Count
     */
    student_count: number | null;
};

/**
 * DistrictSummary
 */
export type DistrictSummary = {
    /**
     * Name
     */
    name: string;
    /**
     * Salary Schedule Link
     */
    salary_schedule_link: string | null;
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Is Covered
     */
    is_covered: boolean;
};

/**
 * LocationSummary
 */
export type LocationSummary = {
    /**
     * Line 1
     */
    line_1: string;
    /**
     * City
     */
    city: string;
    /**
     * State
     */
    state: string;
    /**
     * Zipcode
     */
    zipcode: string;
    /**
     * Latitude
     */
    latitude?: string;
    /**
     * Longitude
     */
    longitude?: string;
};

/**
 * SearchSchoolSummary
 */
export type SearchSchoolSummary = {
    /**
     * Name
     */
    name: string;
    /**
     * Nces Id
     */
    nces_id: string;
    physical_address: LocationSummary;
    district: DistrictSummary;
    /**
     * Grades
     */
    grades: Array<string>;
    school_metadata: NcesSnapshotSchoolSummary;
    /**
     * Matched Jobposting Count
     */
    matched_jobposting_count: number;
    /**
     * Distance From Search Location Miles
     */
    distance_from_search_location_miles: number;
    principal_subscription_status: PrincipalSubscriptionStatus;
    /**
     * Jobpostings
     */
    jobpostings: Array<SearchSchoolJobPostingSummary>;
};

/**
 * SearchSchoolPayload
 */
export type SearchSchoolPayload = {
    /**
     * Page
     */
    page?: number;
    /**
     * Size
     */
    size?: number;
    /**
     * States
     */
    states?: Array<StateAbbreviation>;
    /**
     * School Nces Ids
     */
    school_nces_ids?: Array<string>;
    /**
     * District Nces Ids
     */
    district_nces_ids?: Array<string>;
    /**
     * Allowed District Nces Ids
     */
    allowed_district_nces_ids?: Array<string> | null;
    /**
     * Allowed School Nces Ids
     */
    allowed_school_nces_ids?: Array<string> | null;
    /**
     * Location Latitude
     */
    location_latitude: string | null;
    /**
     * Location Longitude
     */
    location_longitude: string | null;
    /**
     * Distance Radius Miles
     */
    distance_radius_miles: number;
    /**
     * Grades
     */
    grades?: Array<string>;
    /**
     * Subcategories
     */
    subcategories?: Array<string>;
    /**
     * Title
     */
    title?: string | null;
    /**
     * Show Schools Without Roles
     */
    show_schools_without_roles?: boolean;
    /**
     * Jobs Count
     */
    jobs_count: number;
    /**
     * Allow Test Data
     */
    allow_test_data?: boolean;
    /**
     * First Seen After
     */
    first_seen_after?: string | null;
    /**
     * First Seen Before
     */
    first_seen_before?: string | null;
};

/**
 * SearchJobpostingsPayload
 */
export type SearchJobpostingsPayload = {
    /**
     * Page
     */
    page?: number;
    /**
     * Size
     */
    size?: number;
    /**
     * School Nces Ids
     */
    school_nces_ids?: Array<string>;
    /**
     * District Nces Ids
     */
    district_nces_ids?: Array<string>;
    /**
     * Grades
     */
    grades?: Array<string>;
    /**
     * Subcategories
     */
    subcategories?: Array<string>;
    posting_type?: JobPostingType;
};

/**
 * JobPostingType
 */
export const JobPostingType = {
    NON_TEACHING: 'non_teaching',
    TEACHING: 'teaching'
} as const;

/**
 * JobPostingType
 */
export type JobPostingType = typeof JobPostingType[keyof typeof JobPostingType];

/**
 * SearchJobPostingsPage
 */
export type SearchJobPostingsPage = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number;
    /**
     * Size
     */
    size: number;
    /**
     * Pages
     */
    pages: number;
    /**
     * Items
     */
    items: Array<SearchJobPostingSummary>;
};

/**
 * JobPostingSchool
 */
export type JobPostingSchool = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Name
     */
    name: string;
};

/**
 * EmploymentType
 */
export const EmploymentType = {
    FULL_TIME: 'full_time',
    PART_TIME: 'part_time'
} as const;

/**
 * EmploymentType
 */
export type EmploymentType = typeof EmploymentType[keyof typeof EmploymentType];

/**
 * SearchJobPostingSummary
 */
export type SearchJobPostingSummary = {
    /**
     * Date Posted
     */
    date_posted: string | null;
    /**
     * Created At
     */
    created_at: string;
    employment_type: EmploymentType | null;
    /**
     * Job Url
     */
    job_url: string;
    pooled_posting_type: PooledPostingType | null;
    /**
     * Title
     */
    title: string;
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Salary Min
     */
    salary_min: number | null;
    /**
     * Salary Max
     */
    salary_max: number | null;
    posting_type: JobPostingType;
    /**
     * Subcategories
     */
    subcategories: Array<string>;
    /**
     * Schools
     */
    schools: Array<JobPostingSchool>;
};

/**
 * SchoolsPage
 */
export type SchoolsPage = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number;
    /**
     * Size
     */
    size: number;
    /**
     * Pages
     */
    pages: number;
    /**
     * Items
     */
    items: Array<SchoolJobPostingSummary>;
};

/**
 * JobPostingSummary
 */
export type JobPostingSummary = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Title
     */
    title: string;
    /**
     * Subcategories
     */
    subcategories: Array<string>;
    pooled_posting_type: PooledPostingType | null;
};

/**
 * SchoolJobPostingSummary
 */
export type SchoolJobPostingSummary = {
    /**
     * Name
     */
    name: string;
    /**
     * Nces Id
     */
    nces_id: string;
    physical_address: LocationSummary | null;
    district: DistrictSummary | null;
    /**
     * Grades
     */
    grades: Array<string>;
    school_metadata: NcesSnapshotSchoolSummary;
    /**
     * Website
     */
    website: string | null;
    /**
     * Principal Status
     */
    principal_status: string;
    /**
     * Principal Subscription Status
     */
    principal_subscription_status: string;
    /**
     * Distance From Search Location Miles
     */
    distance_from_search_location_miles: number | null;
    /**
     * Jobpostings
     */
    jobpostings: Array<JobPostingSummary>;
};

/**
 * SchoolWithAddress
 */
export type SchoolWithAddress = {
    physical_address: BasicLocationSummaryNoCoords | null;
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Name
     */
    name: string;
};

/**
 * BasicLocationSummaryNoCoords
 */
export type BasicLocationSummaryNoCoords = {
    /**
     * Line 1
     */
    line_1: string;
    /**
     * City
     */
    city: string;
    /**
     * State
     */
    state: string;
    /**
     * Zipcode
     */
    zipcode: string;
};

/**
 * SchoolSoftPreferencesPayload
 */
export type SchoolSoftPreferencesPayload = {
    /**
     * School Nces Ids
     */
    school_nces_ids: Array<string>;
};

/**
 * SchoolSoftPreferencesAttributes
 */
export type SchoolSoftPreferencesAttributes = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Student Teacher Ratio
     */
    student_teacher_ratio: number | null;
    /**
     * Average Salary
     */
    average_salary: number | null;
    /**
     * Novice Teachers Percentage
     */
    novice_teachers_percentage: number | null;
    /**
     * Free Reduced Lunch Percentage
     */
    free_reduced_lunch_percentage: number | null;
    /**
     * Achievement Growth
     */
    achievement_growth: number | null;
};

/**
 * SchoolPromotionData
 */
export type SchoolPromotionData = {
    changes: FullComparisonResultsSchoolComparisonInputSchoolForDeletionInput;
    /**
     * Geolocation Data
     */
    geolocation_data: {
        [key: string]: string;
    };
};

/**
 * SchoolForDeletion
 */
export type SchoolForDeletion = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * State
     */
    state: string;
    /**
     * Job Posting Count
     */
    job_posting_count: number;
    /**
     * District Nces Id
     */
    district_nces_id: string;
};

/**
 * PrincipalStatus
 */
export const PrincipalStatus = {
    SUBSCRIBED: 'subscribed',
    UNSUBSCRIBED: 'unsubscribed'
} as const;

/**
 * PrincipalStatus
 */
export type PrincipalStatus = typeof PrincipalStatus[keyof typeof PrincipalStatus];

/**
 * RecordSource
 */
export const RecordSource = {
    NCES: 'nces',
    MANUAL: 'manual'
} as const;

/**
 * RecordSource
 */
export type RecordSource = typeof RecordSource[keyof typeof RecordSource];

/**
 * SchoolComparisonInput
 */
export type SchoolComparisonInput = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Name
     */
    name: string;
    source: RecordSource;
    /**
     * Student Count
     */
    student_count: number | null;
    /**
     * Locale
     */
    locale: string | null;
    state: StateAbbreviation;
    /**
     * Website
     */
    website: string | null;
    /**
     * Address Line 1
     */
    address_line_1: string;
    /**
     * Address Line 2
     */
    address_line_2: string | null;
    /**
     * Address Line 3
     */
    address_line_3: string | null;
    /**
     * Address City
     */
    address_city: string;
    /**
     * Address County
     */
    address_county: string | null;
    address_state: StateAbbreviation;
    /**
     * Address Zipcode
     */
    address_zipcode: string;
    /**
     * Deleted
     */
    deleted?: boolean;
    /**
     * District Nces Id
     */
    district_nces_id: string;
    /**
     * Charter
     */
    charter: boolean;
    principal_status: PrincipalStatus;
    principal_subscription_status: PrincipalSubscriptionStatus;
    /**
     * Lowest Grade
     */
    lowest_grade: string | null;
    /**
     * Highest Grade
     */
    highest_grade: string | null;
};

/**
 * ExistingEntityComparisonResult
 */
export type ExistingEntityComparisonResult = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Attribute
     */
    attribute: string;
    /**
     * Old Value
     */
    old_value: string | number | boolean | null;
    /**
     * New Value
     */
    new_value: string | number | boolean | null;
};

/**
 * FullComparisonResults[SchoolComparisonInput, SchoolForDeletion]
 */
export type FullComparisonResultsSchoolComparisonInputSchoolForDeletionInput = {
    /**
     * Updates
     */
    updates: Array<ExistingEntityComparisonResult>;
    /**
     * Creates
     */
    creates: Array<SchoolComparisonInput>;
    /**
     * Deletes
     */
    deletes: Array<SchoolForDeletion>;
};

/**
 * SchoolIdAndDistanceMiles
 */
export type SchoolIdAndDistanceMiles = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Distance Miles
     */
    distance_miles: number;
};

/**
 * SchoolCSVDeletePreview
 */
export type SchoolCsvDeletePreview = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * State
     */
    state: string;
    /**
     * District Nces Id
     */
    district_nces_id: string;
};

/**
 * SchoolAutocompleteItem
 */
export type SchoolAutocompleteItem = {
    /**
     * Name
     */
    name: string;
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * District Nces Id
     */
    district_nces_id: string;
    physical_address: BasicLocationSummary;
};

/**
 * BasicLocationSummary
 */
export type BasicLocationSummary = {
    /**
     * City
     */
    city: string;
    /**
     * State
     */
    state: string;
};

/**
 * RawJobPostingType
 */
export const RawJobPostingType = {
    REMOVAL: 'removal',
    ADD_OR_CHANGE: 'add_or_change',
    UNCHANGED: 'unchanged'
} as const;

/**
 * RawJobPostingType
 */
export type RawJobPostingType = typeof RawJobPostingType[keyof typeof RawJobPostingType];

/**
 * RawJobPostingStatus
 */
export const RawJobPostingStatus = {
    PROCESSED: 'processed',
    UNPROCESSED: 'unprocessed'
} as const;

/**
 * RawJobPostingStatus
 */
export type RawJobPostingStatus = typeof RawJobPostingStatus[keyof typeof RawJobPostingStatus];

/**
 * RawJobPostingCreate
 */
export type RawJobPostingCreate = {
    /**
     * Job Url
     */
    job_url: string;
    /**
     * Raw Json
     */
    raw_json: {
        [key: string]: unknown;
    };
    status?: RawJobPostingStatus;
    type: RawJobPostingType;
};

/**
 * RawJobPostingBulkUpdateResponse
 */
export type RawJobPostingBulkUpdateResponse = {
    /**
     * Updated Count
     */
    updated_count: number;
    /**
     * Failed Updates
     */
    failed_updates: Array<FailedBulkUpdate>;
    /**
     * Total Processed
     */
    total_processed: number;
};

/**
 * FailedBulkUpdate
 */
export type FailedBulkUpdate = {
    /**
     * Uuid
     */
    uuid: string | null;
    /**
     * Error
     */
    error: string;
};

/**
 * RawJobPostingBulkUpdate
 */
export type RawJobPostingBulkUpdate = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Raw Json Updates
     */
    raw_json_updates: {
        [key: string]: unknown;
    };
};

/**
 * PromotionResult
 */
export type PromotionResult = {
    districts: ChangeCount;
    schools: ChangeCount;
};

/**
 * ChangeCount
 */
export type ChangeCount = {
    /**
     * Update Count
     */
    update_count: number;
    /**
     * Create Count
     */
    create_count: number;
    /**
     * Delete Count
     */
    delete_count: number;
};

/**
 * PromotionPayload
 */
export type PromotionPayload = {
    /**
     * Approver Name
     */
    approver_name: string;
    /**
     * Diff S3 Key
     */
    diff_s3_key: string;
    districts: DistrictPromotionData;
    schools: SchoolPromotionData;
};

/**
 * DistrictForDeletion
 */
export type DistrictForDeletion = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * State
     */
    state: string;
    /**
     * Job Posting Count
     */
    job_posting_count: number;
    /**
     * School Count
     */
    school_count: number;
};

/**
 * ApplicantTrackingSystem
 */
export const ApplicantTrackingSystem = {
    ACTIVEAPPLICANT: 'activeapplicant',
    ADP: 'adp',
    APPLICANTSTACK: 'applicantstack',
    APPLITRACK: 'applitrack',
    ARCAREERS: 'arcareers',
    ASTIHOSTED: 'astihosted',
    ATSONDEMAND: 'atsondemand',
    BAMBOOHR: 'bamboohr',
    EDJOIN: 'edjoin',
    EDUCATEKANSAS: 'educatekansas',
    EMS_LINQ: 'ems_linq',
    ENTERTIMEONLINE: 'entertimeonline',
    ESS: 'ess',
    EZHIREK12: 'ezhirek12',
    FOUNTAIN: 'fountain',
    HIREBRIDGE: 'hirebridge',
    HRMDIRECT: 'hrmdirect',
    ICIMS: 'icims',
    INDEED: 'indeed',
    JOBADDER: 'jobadder',
    JAZZHR: 'jazzhr',
    JOBVITE: 'jobvite',
    K12JOBSPOT: 'k12jobspot',
    LEVER: 'lever',
    LGC: 'lgc',
    LINKEDIN: 'linkedin',
    MISTAFF: 'mistaff',
    MOCAREERS: 'mocareers',
    MOREAP: 'moreap',
    MOTEACHING: 'moteaching',
    MYSMARTHIRE: 'mysmarthire',
    NINJAGIG: 'ninjagig',
    NIMBLE_ATS_HIRE: 'nimble_ats_hire',
    NIMBLE_ATS_COHIRE: 'nimble_ats_cohire',
    OHIOK12JOBS: 'ohiok12jobs',
    ORACLECLOUD: 'oraclecloud',
    PAYCOM: 'paycom',
    PAYCOR: 'paycor',
    PAYLOCITY: 'paylocity',
    PEOPLEADMIN: 'peopleadmin',
    POWERSCHOOL: 'powerschool',
    RDS: 'rds',
    RDSAPPTRACKING: 'rdsapptracking',
    REDROVER: 'redrover',
    REVELUS: 'revelus',
    SAASHR: 'saashr',
    SCHOOLJOBS: 'schooljobs',
    SCHOOLSPRING: 'schoolspring',
    SCHOOLWIRES: 'schoolwires',
    SMARTRECRUITERS: 'smartrecruiters',
    SKYWARD: 'skyward',
    SKYWARDV2: 'skywardv2',
    SWEEPBOT: 'sweepbot',
    TALENTED: 'talented',
    TALEO: 'taleo',
    TEACHGEORGIA: 'teachgeorgia',
    TEACHINDYNOW: 'teachindynow',
    TEACHERS_TEACHERS: 'teachers_teachers',
    TYLERTECHNOLOGIES: 'tylertechnologies',
    ULTIPRO: 'ultipro',
    WINOCULAR: 'winocular',
    WORKABLE: 'workable',
    WORKDAY: 'workday',
    YOSS: 'yoss'
} as const;

/**
 * ApplicantTrackingSystem
 */
export type ApplicantTrackingSystem = typeof ApplicantTrackingSystem[keyof typeof ApplicantTrackingSystem];

/**
 * DistrictComparisonInput
 */
export type DistrictComparisonInput = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Name
     */
    name: string;
    source: RecordSource;
    /**
     * Student Count
     */
    student_count: number | null;
    /**
     * Locale
     */
    locale: string | null;
    state: StateAbbreviation;
    /**
     * Website
     */
    website: string | null;
    /**
     * Address Line 1
     */
    address_line_1: string;
    /**
     * Address Line 2
     */
    address_line_2: string | null;
    /**
     * Address Line 3
     */
    address_line_3: string | null;
    /**
     * Address City
     */
    address_city: string;
    /**
     * Address County
     */
    address_county: string | null;
    address_state: StateAbbreviation;
    /**
     * Address Zipcode
     */
    address_zipcode: string;
    /**
     * Deleted
     */
    deleted?: boolean;
    /**
     * Ats Url
     */
    ats_url: string | null;
    ats_type: ApplicantTrackingSystem | null;
    /**
     * Salary Schedule Link
     */
    salary_schedule_link: string | null;
    /**
     * Ziprecruiter Company Page Url
     */
    ziprecruiter_company_page_url: string | null;
    /**
     * Indeed Company Page Url
     */
    indeed_company_page_url: string | null;
    /**
     * Permission To Scrape Ats Direct
     */
    permission_to_scrape_ats_direct: boolean | null;
};

/**
 * FullComparisonResults[DistrictComparisonInput, DistrictForDeletion]
 */
export type FullComparisonResultsDistrictComparisonInputDistrictForDeletionInput = {
    /**
     * Updates
     */
    updates: Array<ExistingEntityComparisonResult>;
    /**
     * Creates
     */
    creates: Array<DistrictComparisonInput>;
    /**
     * Deletes
     */
    deletes: Array<DistrictForDeletion>;
};

/**
 * DistrictPromotionData
 */
export type DistrictPromotionData = {
    changes: FullComparisonResultsDistrictComparisonInputDistrictForDeletionInput;
    /**
     * Geolocation Data
     */
    geolocation_data: {
        [key: string]: string;
    };
};

/**
 * PayPeriod
 */
export const PayPeriod = {
    YEARLY: 'yearly',
    HOURLY: 'hourly',
    WEEKLY: 'weekly',
    DAILY: 'daily',
    MONTHLY: 'monthly'
} as const;

/**
 * PayPeriod
 */
export type PayPeriod = typeof PayPeriod[keyof typeof PayPeriod];

/**
 * NewEntityGeolocationPayload
 */
export type NewEntityGeolocationPayload = {
    entity_type: EntityType;
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Existing
     */
    existing: false;
    address_data: GeolocationAddressDataNew;
};

/**
 * GeolocationAddressDataNew
 */
export type GeolocationAddressDataNew = {
    /**
     * Address Line 1
     */
    address_line_1: string;
    /**
     * Address Line 2
     */
    address_line_2: string | null;
    /**
     * Address Line 3
     */
    address_line_3: string | null;
    /**
     * Address City
     */
    address_city: string;
    /**
     * Address County
     */
    address_county: string | null;
    /**
     * Address State
     */
    address_state: string;
    /**
     * Address Zipcode
     */
    address_zipcode: string;
};

/**
 * EntityType
 */
export const EntityType = {
    SCHOOL: 'school',
    DISTRICT: 'district'
} as const;

/**
 * EntityType
 */
export type EntityType = typeof EntityType[keyof typeof EntityType];

/**
 * LocationType
 */
export const LocationType = {
    DISTRICT_WIDE: 'district_wide',
    SPECIFIC_SCHOOLS: 'specific_schools',
    UNMATCHABLE: 'unmatchable',
    BY_GRADES: 'by_grades'
} as const;

/**
 * LocationType
 */
export type LocationType = typeof LocationType[keyof typeof LocationType];

/**
 * JobPostingsPage
 */
export type JobPostingsPage = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number;
    /**
     * Size
     */
    size: number;
    /**
     * Pages
     */
    pages: number;
    /**
     * Items
     */
    items: Array<JobPostingReadDistrictSchool>;
};

/**
 * JobPostingReadDistrictSchool
 *
 * Class for CEDR researchers data in the format intended.
 * Adding a proxy date_scraped field to align with when we pull the export.
 */
export type JobPostingReadDistrictSchool = {
    /**
     * Internal Nimble Id
     */
    internal_nimble_id: string;
    /**
     * Title
     */
    title: string;
    /**
     * Ats Job Id
     */
    ats_job_id: string | null;
    /**
     * First Seen Date
     */
    first_seen_date: string;
    /**
     * Job Description
     */
    job_description: string;
    /**
     * Salary Min
     */
    salary_min: string | null;
    /**
     * Salary Max
     */
    salary_max: string | null;
    /**
     * Job Url
     */
    job_url: string;
    /**
     * Location
     */
    location: string;
    source: JobPostingSource;
    /**
     * Date Posted
     */
    date_posted: string | null;
    pay_period: PayPeriod | null;
    employment_type: EmploymentType | null;
    pooled_posting_type: PooledPostingType | null;
    posting_type: JobPostingType;
    /**
     * Subcategories
     */
    subcategories: Array<string>;
    /**
     * District
     */
    district: {
        [key: string]: unknown;
    };
    /**
     * Schools
     */
    schools: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Date Scraped
     */
    date_scraped?: string;
};

/**
 * JobPostingView
 */
export type JobPostingView = {
    /**
     * Date Posted
     */
    date_posted: string | null;
    /**
     * Created At
     */
    created_at: string;
    employment_type: EmploymentType | null;
    /**
     * Job Url
     */
    job_url: string;
    /**
     * Job Description
     */
    job_description: string;
    pooled_posting_type: PooledPostingType | null;
    /**
     * Title
     */
    title: string;
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Ats Job Id
     */
    ats_job_id: string | null;
    /**
     * Salary Min
     */
    salary_min: number | null;
    /**
     * Salary Max
     */
    salary_max: number | null;
    posting_type: JobPostingType;
    /**
     * Subcategories
     */
    subcategories: Array<string>;
    /**
     * District Nces Id
     */
    district_nces_id: string;
    /**
     * Is Internal
     */
    is_internal: boolean;
};

/**
 * JobPostingRecategorize
 */
export type JobPostingRecategorize = {
    /**
     * Job Url
     */
    job_url: string;
    posting_type: JobPostingType;
    pooled_posting_type: PooledPostingType | null;
    location_type: LocationType | null;
    /**
     * Subcategories
     */
    subcategories: Array<string> | null;
    /**
     * Schools
     */
    schools: Array<string> | null;
    /**
     * Grades
     */
    grades: Array<number> | null;
    /**
     * Posting Type Match Type
     */
    posting_type_match_type: string | null;
};

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
    /**
     * Detail
     */
    detail?: Array<ValidationError>;
};

/**
 * GeolocationAddressDataExisting
 */
export type GeolocationAddressDataExisting = {
    /**
     * Address Line 1
     */
    address_line_1: string | null;
    /**
     * Address Line 2
     */
    address_line_2: string | null;
    /**
     * Address Line 3
     */
    address_line_3: string | null;
    /**
     * Address City
     */
    address_city: string | null;
    /**
     * Address County
     */
    address_county: string | null;
    /**
     * Address State
     */
    address_state: string | null;
    /**
     * Address Zipcode
     */
    address_zipcode: string | null;
};

/**
 * FullComparisonResults[SchoolComparisonInput, SchoolForDeletion]
 */
export type FullComparisonResultsSchoolComparisonInputSchoolForDeletionOutput = {
    /**
     * Updates
     */
    updates: Array<ExistingEntityComparisonResult>;
    /**
     * Creates
     */
    creates: Array<SchoolComparisonInput>;
    /**
     * Deletes
     */
    deletes: Array<SchoolForDeletion>;
};

/**
 * FullComparisonResults[SchoolComparisonInput, SchoolCSVDeletePreview]
 */
export type FullComparisonResultsSchoolComparisonInputSchoolCsvDeletePreview = {
    /**
     * Updates
     */
    updates: Array<ExistingEntityComparisonResult>;
    /**
     * Creates
     */
    creates: Array<SchoolComparisonInput>;
    /**
     * Deletes
     */
    deletes: Array<SchoolCsvDeletePreview>;
};

/**
 * FullComparisonResults[DistrictComparisonInput, DistrictForDeletion]
 */
export type FullComparisonResultsDistrictComparisonInputDistrictForDeletionOutput = {
    /**
     * Updates
     */
    updates: Array<ExistingEntityComparisonResult>;
    /**
     * Creates
     */
    creates: Array<DistrictComparisonInput>;
    /**
     * Deletes
     */
    deletes: Array<DistrictForDeletion>;
};

/**
 * FullComparisonResults[DistrictComparisonInput, DistrictCSVDeletePreview]
 */
export type FullComparisonResultsDistrictComparisonInputDistrictCsvDeletePreview = {
    /**
     * Updates
     */
    updates: Array<ExistingEntityComparisonResult>;
    /**
     * Creates
     */
    creates: Array<DistrictComparisonInput>;
    /**
     * Deletes
     */
    deletes: Array<DistrictCsvDeletePreview>;
};

/**
 * DistrictCSVDeletePreview
 */
export type DistrictCsvDeletePreview = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * State
     */
    state: string;
};

/**
 * FullAddressItem
 */
export type FullAddressItem = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Line 1
     */
    line_1: string;
    /**
     * Line 2
     */
    line_2: string | null;
    /**
     * Line 3
     */
    line_3: string | null;
    /**
     * City
     */
    city: string;
    /**
     * County
     */
    county: string | null;
    /**
     * State
     */
    state: string;
    /**
     * Zipcode
     */
    zipcode: string;
    /**
     * Latitude
     */
    latitude: string | null;
    /**
     * Longitude
     */
    longitude: string | null;
};

/**
 * ExistingEntityGeolocationPayload
 */
export type ExistingEntityGeolocationPayload = {
    entity_type: EntityType;
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Existing
     */
    existing: true;
    address_data: GeolocationAddressDataExisting;
};

/**
 * ETLStages
 */
export const EtlStages = {
    STAGE1: 'stage1',
    STAGE2: 'stage2'
} as const;

/**
 * ETLStages
 */
export type EtlStages = typeof EtlStages[keyof typeof EtlStages];

/**
 * ETLLogsCreate
 */
export type EtlLogsCreate = {
    etl_stage: EtlStages;
    source: JobPostingSource;
    /**
     * Success Json
     */
    success_json: {
        [key: string]: unknown;
    };
    /**
     * Errors Json
     */
    errors_json: {
        [key: string]: unknown;
    };
};

/**
 * DistrictWithStateAbbreviation
 */
export type DistrictWithStateAbbreviation = {
    /**
     * Uuid
     */
    uuid?: string;
    /**
     * Updated At
     */
    updated_at?: string;
    /**
     * Created At
     */
    created_at?: string;
    /**
     * Name
     */
    name: string;
    /**
     * Website
     */
    website: string | null;
    /**
     * State Uuid
     */
    state_uuid: string;
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Physical Address Uuid
     */
    physical_address_uuid: string;
    /**
     * Consortium Uuid
     */
    consortium_uuid: string | null;
    /**
     * Ats Url
     */
    ats_url: string | null;
    /**
     * Ziprecruiter Company Page Url
     */
    ziprecruiter_company_page_url: string | null;
    /**
     * Indeed Company Page Url
     */
    indeed_company_page_url: string | null;
    ats_type?: ApplicantTrackingSystem | null;
    /**
     * Salary Schedule Link
     */
    salary_schedule_link: string | null;
    /**
     * Permission To Scrape Ats Direct
     */
    permission_to_scrape_ats_direct: boolean | null;
    source: RecordSource;
    /**
     * Locale
     */
    locale: string | null;
    /**
     * Student Count
     */
    student_count: number | null;
    state_abbreviation: StateAbbreviation;
};

/**
 * DistrictWithSchoolsAndAddresses
 */
export type DistrictWithSchoolsAndAddresses = {
    /**
     * Schools
     */
    schools: Array<SchoolWithAddress>;
    physical_address: BasicLocationSummaryNoCoords | null;
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Name
     */
    name: string;
};

/**
 * DistrictWithSchools
 */
export type DistrictWithSchools = {
    /**
     * Uuid
     */
    uuid?: string;
    /**
     * Updated At
     */
    updated_at?: string;
    /**
     * Created At
     */
    created_at?: string;
    /**
     * Name
     */
    name: string;
    /**
     * Website
     */
    website: string | null;
    /**
     * State Uuid
     */
    state_uuid: string;
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Physical Address Uuid
     */
    physical_address_uuid: string;
    /**
     * Consortium Uuid
     */
    consortium_uuid: string | null;
    /**
     * Ats Url
     */
    ats_url: string | null;
    /**
     * Ziprecruiter Company Page Url
     */
    ziprecruiter_company_page_url: string | null;
    /**
     * Indeed Company Page Url
     */
    indeed_company_page_url: string | null;
    ats_type?: ApplicantTrackingSystem | null;
    /**
     * Salary Schedule Link
     */
    salary_schedule_link: string | null;
    /**
     * Permission To Scrape Ats Direct
     */
    permission_to_scrape_ats_direct: boolean | null;
    source: RecordSource;
    /**
     * Locale
     */
    locale: string | null;
    /**
     * Student Count
     */
    student_count: number | null;
};

/**
 * DistrictSchoolItem
 */
export type DistrictSchoolItem = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Name
     */
    name: string;
    /**
     * Nces Id
     */
    nces_id: string;
    address: FullAddressItem;
    /**
     * Grades
     */
    grades: Array<string>;
};

/**
 * DistrictNcesDetail
 */
export type DistrictNcesDetail = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Name
     */
    name: string;
    /**
     * Nces Id
     */
    nces_id: string;
    state_abbreviation: StateAbbreviation;
    address: FullAddressItem;
    /**
     * Schools
     */
    schools: Array<DistrictSchoolItem>;
    /**
     * Salary Schedule Link
     */
    salary_schedule_link: string | null;
    /**
     * School Count
     */
    school_count: number;
    /**
     * Job Posting Count
     */
    job_posting_count: number;
    /**
     * Student Count
     */
    student_count: number | null;
    /**
     * Locale
     */
    locale: string | null;
};

/**
 * DistrictListItem
 */
export type DistrictListItem = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Name
     */
    name: string;
    /**
     * Nces Id
     */
    nces_id: string;
    state_abbreviation: StateAbbreviation;
};

/**
 * DistrictDetail
 */
export type DistrictDetail = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Name
     */
    name: string;
    /**
     * Nces Id
     */
    nces_id: string;
    state_abbreviation: StateAbbreviation;
    address: FullAddressItem;
    /**
     * Schools
     */
    schools: Array<DistrictSchoolItem>;
};

/**
 * DistrictAtsTypeItem
 */
export type DistrictAtsTypeItem = {
    /**
     * Nces Id
     */
    nces_id: string;
    ats_type: ApplicantTrackingSystem;
};

/**
 * DataSyncAPIResponse[dict[str, str]]
 */
export type DataSyncApiResponseDictStrStr = {
    /**
     * Success
     */
    success: boolean;
    /**
     * Message
     */
    message: string;
    /**
     * Error
     */
    error?: {
        [key: string]: unknown;
    } | null;
    /**
     * Data
     */
    data?: {
        [key: string]: string;
    } | null;
};

/**
 * DataSyncAPIResponse[PromotionResult]
 */
export type DataSyncApiResponsePromotionResult = {
    /**
     * Success
     */
    success: boolean;
    /**
     * Message
     */
    message: string;
    /**
     * Error
     */
    error?: {
        [key: string]: unknown;
    } | null;
    data?: PromotionResult | null;
};

/**
 * DataSyncAPIResponse[FullComparisonResults[SchoolComparisonInput, SchoolForDeletion]]
 */
export type DataSyncApiResponseFullComparisonResultsSchoolComparisonInputSchoolForDeletion = {
    /**
     * Success
     */
    success: boolean;
    /**
     * Message
     */
    message: string;
    /**
     * Error
     */
    error?: {
        [key: string]: unknown;
    } | null;
    data?: FullComparisonResultsSchoolComparisonInputSchoolForDeletionOutput | null;
};

/**
 * DataSyncAPIResponse[FullComparisonResults[SchoolComparisonInput, SchoolCSVDeletePreview]]
 */
export type DataSyncApiResponseFullComparisonResultsSchoolComparisonInputSchoolCsvDeletePreview = {
    /**
     * Success
     */
    success: boolean;
    /**
     * Message
     */
    message: string;
    /**
     * Error
     */
    error?: {
        [key: string]: unknown;
    } | null;
    data?: FullComparisonResultsSchoolComparisonInputSchoolCsvDeletePreview | null;
};

/**
 * DataSyncAPIResponse[FullComparisonResults[DistrictComparisonInput, DistrictForDeletion]]
 */
export type DataSyncApiResponseFullComparisonResultsDistrictComparisonInputDistrictForDeletion = {
    /**
     * Success
     */
    success: boolean;
    /**
     * Message
     */
    message: string;
    /**
     * Error
     */
    error?: {
        [key: string]: unknown;
    } | null;
    data?: FullComparisonResultsDistrictComparisonInputDistrictForDeletionOutput | null;
};

/**
 * DataSyncAPIResponse[FullComparisonResults[DistrictComparisonInput, DistrictCSVDeletePreview]]
 */
export type DataSyncApiResponseFullComparisonResultsDistrictComparisonInputDistrictCsvDeletePreview = {
    /**
     * Success
     */
    success: boolean;
    /**
     * Message
     */
    message: string;
    /**
     * Error
     */
    error?: {
        [key: string]: unknown;
    } | null;
    data?: FullComparisonResultsDistrictComparisonInputDistrictCsvDeletePreview | null;
};

/**
 * CohireExportJobItem
 */
export type CohireExportJobItem = {
    /**
     * Id
     */
    id: string;
    /**
     * Title
     */
    title: string;
    /**
     * Job Description
     */
    job_description: string;
    /**
     * Job Url
     */
    job_url: string;
    ai_posting_type: JobPostingType;
    /**
     * Ai Subcategories
     */
    ai_subcategories: Array<string>;
    employment_type: EmploymentType | null;
    /**
     * Hiring Unit Uuids
     */
    hiring_unit_uuids: Array<string>;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Date Posted
     */
    date_posted: null;
    /**
     * Date Closed
     */
    date_closed: null;
    /**
     * Salary Min
     */
    salary_min: null;
    /**
     * Salary Max
     */
    salary_max: null;
    /**
     * Pay Period
     */
    pay_period: null;
    /**
     * Pooled Posting Type
     */
    pooled_posting_type: null;
};

/**
 * CohireExportHiringUnit
 */
export type CohireExportHiringUnit = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Name
     */
    name: string;
    address: CohireExportAddress;
    /**
     * Grades
     */
    grades: Array<string>;
};

/**
 * CohireExportAddress
 */
export type CohireExportAddress = {
    /**
     * Line1
     */
    line1: string;
    /**
     * Line2
     */
    line2: string | null;
    /**
     * Line3
     */
    line3: string | null;
    /**
     * City
     */
    city: string;
    /**
     * County
     */
    county: string | null;
    /**
     * State
     */
    state: string;
    /**
     * Zipcode
     */
    zipcode: string;
    /**
     * Latitude
     */
    latitude: number;
    /**
     * Longitude
     */
    longitude: number;
};

/**
 * CohireExportDistrictItem
 */
export type CohireExportDistrictItem = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Name
     */
    name: string;
    address: CohireExportAddress;
    /**
     * Hiring Units
     */
    hiring_units: Array<CohireExportHiringUnit>;
};

/**
 * Body_compare_school_csvs_api_v1_data_sync_schools_compare_csv__post
 */
export type BodyCompareSchoolCsvsApiV1DataSyncSchoolsCompareCsvPost = {
    /**
     * Previous
     */
    previous: Blob | File;
    /**
     * Current
     */
    current: Blob | File;
};

/**
 * Body_compare_district_csvs_api_v1_data_sync_districts_compare_csv__post
 */
export type BodyCompareDistrictCsvsApiV1DataSyncDistrictsCompareCsvPost = {
    /**
     * Previous
     */
    previous: Blob | File;
    /**
     * Current
     */
    current: Blob | File;
};

/**
 * AtsType
 */
export type AtsType = {
    name: ApplicantTrackingSystem;
    coverage_status: AtsCoverageStatus;
};

/**
 * ATSCoverageStatus
 */
export const AtsCoverageStatus = {
    ACTIVELY_SCRAPING: 'actively_scraping',
    SCRAPER_NOT_IMPLEMENTED: 'scraper_not_implemented',
    NOT_SCRAPABLE: 'not_scrapable'
} as const;

/**
 * ATSCoverageStatus
 */
export type AtsCoverageStatus = typeof AtsCoverageStatus[keyof typeof AtsCoverageStatus];

export type GetDistrictsByAtsTypesApiV1DistrictsByAtsTypeGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Ats Types
         */
        ats_types?: Array<ApplicantTrackingSystem>;
    };
    url: '/api/v1/districts/by-ats-type';
};

export type GetDistrictsByAtsTypesApiV1DistrictsByAtsTypeGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDistrictsByAtsTypesApiV1DistrictsByAtsTypeGetError = GetDistrictsByAtsTypesApiV1DistrictsByAtsTypeGetErrors[keyof GetDistrictsByAtsTypesApiV1DistrictsByAtsTypeGetErrors];

export type GetDistrictsByAtsTypesApiV1DistrictsByAtsTypeGetResponses = {
    /**
     * Response Get Districts By Ats Types Api V1 Districts By Ats Type Get
     *
     * Successful Response
     */
    200: Array<DistrictAtsTypeItem>;
};

export type GetDistrictsByAtsTypesApiV1DistrictsByAtsTypeGetResponse = GetDistrictsByAtsTypesApiV1DistrictsByAtsTypeGetResponses[keyof GetDistrictsByAtsTypesApiV1DistrictsByAtsTypeGetResponses];

export type GetDistrictsSummaryApiV1DistrictsSummaryGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * State Abbreviation
         */
        state_abbreviation?: Array<StateAbbreviation>;
    };
    url: '/api/v1/districts/summary';
};

export type GetDistrictsSummaryApiV1DistrictsSummaryGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDistrictsSummaryApiV1DistrictsSummaryGetError = GetDistrictsSummaryApiV1DistrictsSummaryGetErrors[keyof GetDistrictsSummaryApiV1DistrictsSummaryGetErrors];

export type GetDistrictsSummaryApiV1DistrictsSummaryGetResponses = {
    /**
     * Response Get Districts Summary Api V1 Districts Summary Get
     *
     * Successful Response
     */
    200: Array<DistrictListItem>;
};

export type GetDistrictsSummaryApiV1DistrictsSummaryGetResponse = GetDistrictsSummaryApiV1DistrictsSummaryGetResponses[keyof GetDistrictsSummaryApiV1DistrictsSummaryGetResponses];

export type GetDistrictsWithSchoolsApiV1DistrictsAllWithSchoolsGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Nces Ids
         */
        nces_ids?: Array<string>;
    };
    url: '/api/v1/districts/all-with-schools';
};

export type GetDistrictsWithSchoolsApiV1DistrictsAllWithSchoolsGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDistrictsWithSchoolsApiV1DistrictsAllWithSchoolsGetError = GetDistrictsWithSchoolsApiV1DistrictsAllWithSchoolsGetErrors[keyof GetDistrictsWithSchoolsApiV1DistrictsAllWithSchoolsGetErrors];

export type GetDistrictsWithSchoolsApiV1DistrictsAllWithSchoolsGetResponses = {
    /**
     * Response Get Districts With Schools Api V1 Districts All With Schools Get
     *
     * Successful Response
     */
    200: Array<DistrictWithSchoolsAndAddresses>;
};

export type GetDistrictsWithSchoolsApiV1DistrictsAllWithSchoolsGetResponse = GetDistrictsWithSchoolsApiV1DistrictsAllWithSchoolsGetResponses[keyof GetDistrictsWithSchoolsApiV1DistrictsAllWithSchoolsGetResponses];

export type GetDistrictByNcesIdApiV1DistrictsByNcesIdNcesIdGetData = {
    body?: never;
    path: {
        /**
         * Nces Id
         */
        nces_id: string;
    };
    query?: never;
    url: '/api/v1/districts/by-nces-id/{nces_id}';
};

export type GetDistrictByNcesIdApiV1DistrictsByNcesIdNcesIdGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDistrictByNcesIdApiV1DistrictsByNcesIdNcesIdGetError = GetDistrictByNcesIdApiV1DistrictsByNcesIdNcesIdGetErrors[keyof GetDistrictByNcesIdApiV1DistrictsByNcesIdNcesIdGetErrors];

export type GetDistrictByNcesIdApiV1DistrictsByNcesIdNcesIdGetResponses = {
    /**
     * Successful Response
     */
    200: DistrictNcesDetail;
};

export type GetDistrictByNcesIdApiV1DistrictsByNcesIdNcesIdGetResponse = GetDistrictByNcesIdApiV1DistrictsByNcesIdNcesIdGetResponses[keyof GetDistrictByNcesIdApiV1DistrictsByNcesIdNcesIdGetResponses];

export type GetDistrictApiV1DistrictsDistrictUuidGetData = {
    body?: never;
    path: {
        /**
         * District Uuid
         */
        district_uuid: string;
    };
    query?: never;
    url: '/api/v1/districts/{district_uuid}';
};

export type GetDistrictApiV1DistrictsDistrictUuidGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDistrictApiV1DistrictsDistrictUuidGetError = GetDistrictApiV1DistrictsDistrictUuidGetErrors[keyof GetDistrictApiV1DistrictsDistrictUuidGetErrors];

export type GetDistrictApiV1DistrictsDistrictUuidGetResponses = {
    /**
     * Successful Response
     */
    200: DistrictDetail;
};

export type GetDistrictApiV1DistrictsDistrictUuidGetResponse = GetDistrictApiV1DistrictsDistrictUuidGetResponses[keyof GetDistrictApiV1DistrictsDistrictUuidGetResponses];

export type GetSchoolsAutocompleteApiV1SchoolsAutocompleteGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * State Abbreviation
         */
        state_abbreviation?: Array<StateAbbreviation>;
    };
    url: '/api/v1/schools/autocomplete';
};

export type GetSchoolsAutocompleteApiV1SchoolsAutocompleteGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSchoolsAutocompleteApiV1SchoolsAutocompleteGetError = GetSchoolsAutocompleteApiV1SchoolsAutocompleteGetErrors[keyof GetSchoolsAutocompleteApiV1SchoolsAutocompleteGetErrors];

export type GetSchoolsAutocompleteApiV1SchoolsAutocompleteGetResponses = {
    /**
     * Response Get Schools Autocomplete Api V1 Schools Autocomplete Get
     *
     * Successful Response
     */
    200: Array<SchoolAutocompleteItem>;
};

export type GetSchoolsAutocompleteApiV1SchoolsAutocompleteGetResponse = GetSchoolsAutocompleteApiV1SchoolsAutocompleteGetResponses[keyof GetSchoolsAutocompleteApiV1SchoolsAutocompleteGetResponses];

export type SearchSchoolsApiV1SchoolsSearchPostData = {
    body: SearchSchoolPayload;
    path?: never;
    query?: never;
    url: '/api/v1/schools/search';
};

export type SearchSchoolsApiV1SchoolsSearchPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SearchSchoolsApiV1SchoolsSearchPostError = SearchSchoolsApiV1SchoolsSearchPostErrors[keyof SearchSchoolsApiV1SchoolsSearchPostErrors];

export type SearchSchoolsApiV1SchoolsSearchPostResponses = {
    /**
     * Successful Response
     */
    200: SearchSchoolsPage;
};

export type SearchSchoolsApiV1SchoolsSearchPostResponse = SearchSchoolsApiV1SchoolsSearchPostResponses[keyof SearchSchoolsApiV1SchoolsSearchPostResponses];

export type GetSchoolsByDistanceApiV1SchoolsByDistanceGetData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Latitude
         */
        latitude: number;
        /**
         * Longitude
         */
        longitude: number;
        /**
         * Radius Miles
         */
        radius_miles: number;
    };
    url: '/api/v1/schools/by-distance';
};

export type GetSchoolsByDistanceApiV1SchoolsByDistanceGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSchoolsByDistanceApiV1SchoolsByDistanceGetError = GetSchoolsByDistanceApiV1SchoolsByDistanceGetErrors[keyof GetSchoolsByDistanceApiV1SchoolsByDistanceGetErrors];

export type GetSchoolsByDistanceApiV1SchoolsByDistanceGetResponses = {
    /**
     * Response Get Schools By Distance Api V1 Schools By Distance Get
     *
     * Successful Response
     */
    200: Array<SchoolIdAndDistanceMiles>;
};

export type GetSchoolsByDistanceApiV1SchoolsByDistanceGetResponse = GetSchoolsByDistanceApiV1SchoolsByDistanceGetResponses[keyof GetSchoolsByDistanceApiV1SchoolsByDistanceGetResponses];

export type PostSchoolsSoftPreferencesAttributesApiV1SchoolsSoftPreferencesAttributesPostData = {
    body: SchoolSoftPreferencesPayload;
    path?: never;
    query?: never;
    url: '/api/v1/schools/soft-preferences-attributes';
};

export type PostSchoolsSoftPreferencesAttributesApiV1SchoolsSoftPreferencesAttributesPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PostSchoolsSoftPreferencesAttributesApiV1SchoolsSoftPreferencesAttributesPostError = PostSchoolsSoftPreferencesAttributesApiV1SchoolsSoftPreferencesAttributesPostErrors[keyof PostSchoolsSoftPreferencesAttributesApiV1SchoolsSoftPreferencesAttributesPostErrors];

export type PostSchoolsSoftPreferencesAttributesApiV1SchoolsSoftPreferencesAttributesPostResponses = {
    /**
     * Response Post Schools Soft Preferences Attributes Api V1 Schools Soft Preferences Attributes Post
     *
     * Successful Response
     */
    200: Array<SchoolSoftPreferencesAttributes>;
};

export type PostSchoolsSoftPreferencesAttributesApiV1SchoolsSoftPreferencesAttributesPostResponse = PostSchoolsSoftPreferencesAttributesApiV1SchoolsSoftPreferencesAttributesPostResponses[keyof PostSchoolsSoftPreferencesAttributesApiV1SchoolsSoftPreferencesAttributesPostResponses];

export type GetJobpostingApiV1JobpostingsJobJobUuidGetData = {
    body?: never;
    path: {
        /**
         * Job Uuid
         */
        job_uuid: string;
    };
    query?: never;
    url: '/api/v1/jobpostings/job/{job_uuid}';
};

export type GetJobpostingApiV1JobpostingsJobJobUuidGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetJobpostingApiV1JobpostingsJobJobUuidGetError = GetJobpostingApiV1JobpostingsJobJobUuidGetErrors[keyof GetJobpostingApiV1JobpostingsJobJobUuidGetErrors];

export type GetJobpostingApiV1JobpostingsJobJobUuidGetResponses = {
    /**
     * Successful Response
     */
    200: JobPostingView;
};

export type GetJobpostingApiV1JobpostingsJobJobUuidGetResponse = GetJobpostingApiV1JobpostingsJobJobUuidGetResponses[keyof GetJobpostingApiV1JobpostingsJobJobUuidGetResponses];

export type SearchJobpostingsApiV1JobpostingsSearchPostData = {
    body: SearchJobpostingsPayload;
    path?: never;
    query?: never;
    url: '/api/v1/jobpostings/search';
};

export type SearchJobpostingsApiV1JobpostingsSearchPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SearchJobpostingsApiV1JobpostingsSearchPostError = SearchJobpostingsApiV1JobpostingsSearchPostErrors[keyof SearchJobpostingsApiV1JobpostingsSearchPostErrors];

export type SearchJobpostingsApiV1JobpostingsSearchPostResponses = {
    /**
     * Successful Response
     */
    200: SearchJobPostingsPage;
};

export type SearchJobpostingsApiV1JobpostingsSearchPostResponse = SearchJobpostingsApiV1JobpostingsSearchPostResponses[keyof SearchJobpostingsApiV1JobpostingsSearchPostResponses];
